import axios from './factory';
import router from '@/router/index'
import Vue from "vue";
//引入增强js
import '@/util/extends/toFirstUpperCase'
import {setCookie, getCookie, getQueryString } from '@/util/extends/cookieExpand'

//没有api的配置链接加上static,自动分类
//这叫api树

class ApiConfig {
    constructor() {
        this.api = {}

        this.api.system = { //通用
            dictionaryList: { mock: "/cases/kn/dictionaryCache/getDictionaryCacheListByCode", server: "cases/kn/dictionaryCache/getDictionaryCacheListByCode" }, //根据字典编码获取下级字典列表
            authorization: { mock: "oss/authorization", server: "api/oss/authorization" }, //获取oss临时账户
            // getToken: {mock: "auth/token", server: "platform/auth/token"}, //获取token临时账户
        };

        this.api.user = { //用户相关
            getCurrent: { mock: "/cases/common/getCurrentUser", server: "mtdsaccount/account-order/current-user" }, //获取当前登录用户
            getUserMenuList: { mock: "/cases/kn/user/getUserMenuList", server: "mtdsaccount/account-order/menu" }, //获取当前登录用户菜单权限
            setUserLogout: { mock: "/logout", server: "logout" }, //退出登录
        };
        this.api.menu = { //menu的mock数据在access里面
            listByUser: { mock: "/menu/listByUser", server: "cases/ucenter/menu/getMenusToUser.json" }, //获取用户所有菜单功能
            getUserMenuListByUser: { mock: "ucenterapi/uc/internal/common/getUserMenuListByUserId", server: "ucenterapi/uc/internal/common/getUserMenuListByUserId" }, //用户中心权限菜单
            // ucenterMenu: { mock: "/api/ucenter/menu/getMenusToUser.json", server: "/api/ucenter/menu/getMenusToUser.json",base:'http://ucenteruat.oppein.com'}, //用户中心权限菜单
        };
        this.api.session = {
            //util/session.js中用到的接口
            getPrinvin: { mock: "/cases/kn/regionCache/findProvince", server: "cases/kn/regionCache/findProvince" },
            // 请求省
            getFindChildren: { mock: "/cases/kn/regionCache/findChildren", server: "cases/kn/regionCache/findChildren" }, //请求市区街道
        };

        this.api.accountQuery = { //账号已购服务查询
            user: { mock: "/accountOrder/query", server: "mtdsaccount/account-order/query" },
            service: { mock: '/account-order-item/query/on-order-service', server: 'mtdsaccount/account-order-item/query/on-order-service' }, //设计软件订单管理 已购服务
            queryOrderInfo: { mock: '/account-order/query', server: 'mtdsaccount/account-order/query/{id}' }, //设计软件订单管理 根据id查看订单信息
            ReSubmit: { mock: '/account-order/submit', server: 'mtdsaccount/account-order/submit/{accountOrderId}' }, //设计软件订单管理 重新提交
            deleteOreder: { mock: '/account-order/delete/{id}', server: 'mtdsaccount/account-order/delete/{id}' }, //设计软件订单管理  订单删除
            queryBrand: { mock: '/account-order/query-brand', server: 'mtdsaccount/account-order/query-brand' }, //设计软件订单管理 品牌种类
            queryService: { mock: '/account-order/query-service', server: 'mtdsaccount/account-order/query-service' }, //设计软件订单管理 服务
            generateBudget: { mock: '/account-order/generate-budget', server: 'mtdsaccount/account-order/generate-budget/{accountOrderId}' }, //设计软件订单管理 生成预算
            saveOrder: { mock: '/account-order/save', server: 'mtdsaccount/account-order/save' }, //设计软件订单管getAgentDepartmentTree理 保存订单
            submitOrder: { mock: '/account-order/save-submit', server: 'mtdsaccount/account-order/save-submit' }, //设计软件订单管理 提交订单接口
            queryOrderedInfo: { mock: '/mtdsaccount/account-order-item/query', server: 'mtdsaccount/account-order-item/query/{designerId}' }, //设计软件订单管理 已购订单信息
            treeListUrl: { mock: "/ucenterapi/uc/internal/department/getAgentDepartmentTree", server: "ucenterapi/uc/internal/department/getAgentDepartmentTree_V2" }, //获取组织树
            getTreeList: {
                mock: "/ucenterapi/uc/internal/department/getAgentDepartmentTree",
                server: "ucenterapi/uc/internal/department/getOrganizationalStructureTreeToMTDSByOrgType"
            }, //获取组织树
            getDepartmentListByNo: { mock: "/mtdsaccount/ucenterapi/internal/department/getDepartmentListByNo", server: "mtdsaccount/ucenterapi/internal/department/getDepartmentListByNo" }, //根据商场编号获取商场详情
            getUserListByOrgId: { mock: "ucenterapi/user/getUserListByOrgId", server: "ucenterapi/user/getUserListByOrgId" }, //获取部门员工
            // getMarketUserList: { mock: "/ucenterapi/uc/internal/user/getMarketUserListByQueryVo", server: "ucenterapi/uc/internal/user/getMarketUserListByQueryVo" }, //获取人员列表
            getMarketUserList: { mock: "/ucenterapi/uc/internal/user/getMarketUserListByQueryVo", server: "ucenterapi/uc/internal/user/getMarketUserListByQueryVo_V2" }, //获取人员列表
            getMarketListForDepartmentId: { mock: "/ucenterapi/uc/internal/user/getMarketUserListByQueryVo", server: "ucenterapi/uc/internal/department/getMarketListForDepartmentId_V2" }, //获取人员列表
            queryBindingStatusByUserId: { mock: "/mtdsaccount/account-order-item/query/bind-list-status/{userId}", server: "mtdsaccount/account-order-item/query/bind-list-status/{userId}" },
            ssologin: { mock: "/mtdsaccount/account-order-item/sso-login/{userId}", server: "mtdsaccount/account-order-item/sso-login/{userId}" },
            bindingAccount: { mock: "/mtdsaccount/account-order-item/binding", server: "mtdsaccount/account-order-item/binding" },
            // unBindingAccount: { mock: "/mtdsaccount/account-order-item/unbinding", server: "mtdsaccount/account-order-item/unbinding" },
            recharge: { mock: '/account-order/recharge', server: 'mtdsaccount/account-order/recharge' }, //设计软件充值页面
            editAudit: { mock: '/account-order/editAudit', server: 'mtdsaccount/account-audit/editAudit' }, //校验单个订单状态
            editBatchAudit: { mock: '/account-order/editBatchAudit', server: 'mtdsaccount/account-audit/editBatchAudit' }, //校验多个订单状态
            // editAuditResult: { mock: '/account-order/editAuditResult', server: 'mtdsaccount/account-audit/editAuditResult' }, //订单审核，通过，驳回，撤销
            editAuditResult: { mock: '/account-audit/batchAuditOrders', server: 'mtdsaccount/account-audit/batchAuditOrder' }, //订单审核，通过，驳回，撤销
            selectAuditOrder: { mock: '/account-order/selectAuditOrder', server: 'mtdsaccount/account-audit/selectAuditOrder' }, //获取驳回和撤销订单列表
            exportAudit: { mock: '/account-order/exportAudit', server: 'mtdsaccount/account-audit/exportAudit' }, //导出审核列表
            queryAccountOrderForAuditor: { mock: '/account-order/queryAccountOrderForAuditor', server: 'mtdsaccount/account-order/queryAccountOrderForAuditor' }, //审核列表
            accountOrderServiceQuery: { mock: 'account-order-service/query', server: 'account-order-service/query' }, //获取计费项目列表(高级搜索中用到)
            accountOrderServic: { mock: '/account-order-service/queryByPage', server: 'account-order-service/queryByPage' }, //计费项目分页查询
            getBillingStandard: { server: 'mtdsbilling/billing/billingItem/getBillingStandard' }, //查询各计费项目对应的状态与收费标准
            getItemListByParams: { server: 'mtdsbilling/billing/billingItem/itemListByParams' }, //分页查询计费项目信息接口
            queryBillingItemInfoDetailPage: { server: 'mtdsbilling/billing/billingItem/queryBillingItemInfoDetailPage' }, //分页查询计费项目信息接口 - 新 - 从新增页面调用
            // 账号已购买服务查询
            getBoughtService: { server: 'mtdsaccount/account-order/query-boughtService', },
            // 订单保存接口
            save: { server: 'mtdsaccount/account-order/save', },
            saveAfterAuthCompeat: { server: 'mtdsaccount/account-order/saveAfterAuthCompeat', },
            getExternalSystemOrderPage: { server: 'mtdsaccount//account_external_system_order/getExternalSystemOrderPage', }, // 渠道订单列表
            // getProductTypes: {server: 'ucenterapi/market/getProductTypes',},
            getProductTypes: { server: 'ucenterapi/uc/internal/market/getMarketProductChannel', },

            getBeAuditedNameList: { mock: '/account-audit/getBeAuditedNameList', server: 'mtdsaccount/account-audit/getBeAuditedNameList' }, //获取可审核计费项目
            getDictListByTypeToMTDS: { mock: '/dict/getDictListByTypeToMTDS', server: 'ucenterapi/dict/getDictListByTypeToMTDS' }, //（商场组织管理）获取相关商场相关字典
            getUserStatusByIds: { server: 'ucenterapi/user/getUserStatusByIds', },
          getAuditRate: { server: 'mtdsaccount/account-audit/getAuditRate'}, // 审核进度

            getUserPageByOrgNo: { server: 'mtdsaccount/ucenterapi/internal/getUserPageByOrgNo', }, // 获取本组织编码下的启用的人员(分页)
            getAccountByCon: { server: 'mtdsaccount/account-binding/getAccountByConByInternal', }, // 带条件查询绑定关系接口列表
            unbinding: { server: 'mtdsaccount/account-binding/unbinding', }, // 解绑(内部调用)
            binding: { server: 'mtdsaccount/account-binding/binding', }, // 绑定(内部调用)
            exportExternalSystemOrder: { mock: 'account/exportExternalSystemOrder', server: 'account/exportExternalSystemOrder' }, //渠道订单导出
            saveRevokeOrders: { mock: 'mtdsaccount/account-order/saveRevokeOrders', server: 'mtdsaccount/account-order/saveRevokeOrders' }, //渠道订单导出
            getExternalSystemOrdersByMTDSOrderNo: { mock: 'mtdsaccount/account_external_system_order/getExternalSystemOrdersByMTDSOrderNo', server: 'mtdsaccount/account_external_system_order/getExternalSystemOrdersByMTDSOrderNo' }, //渠道订单导出
            authBindingAccount: { mock: 'mtdsaccount/account-binding/authBindingAccount', server: 'mtdsaccount/account-binding/authBindingAccount' }, //校验是否有绑定关系
            gotoSwj: { mock: 'mtdsaccount/swjia/gotoSwj', server: 'mtdsaccount/swjia/gotoSwj' }, //获取三维家链接接口
            getLoginKjl: { mock: 'mtdsaccount/kjl/getLogin', server: 'mtdsaccount/kjl/getLogin' }, //获取三维家链接接口
            bindingByExernalSystemAccount: { mock: 'mtdsaccount/account-binding/bindingByExernalSystemAccount', server: 'mtdsaccount/account-binding/bindingByExernalSystemAccount' }, //校验是否有绑定关系
            batchAuditRevokeOrders: { mock: 'mtdsaccount/account-audit/batchAuditRevokeOrders', server: 'mtdsaccount/account-audit/batchAuditRevokeOrders' }, //撤销订单审核接口

            queryByInterior: { mock: "/accountOrder/queryByInterior", server: "mtdsaccount/account-order/queryByInterior" }, //设计软件账号购买订单列表(集团内部入口)
            queryAccountOrderForAuditorByInterior: { mock: '/account-order/queryAccountOrderForAuditorByInterior', server: 'mtdsaccount/account-order/queryAccountOrderForAuditorByInterior' }, //设计软件账号审核订单列表(集团内部入口)
            exportAuditByInterori: { mock: '/account-order/exportAudit', server: 'mtdsaccount/account-audit/exportAuditByInterori' }, //设计软账号购买-导出更多明细(集团内部入口)
            saveByInterior: { mock: '/account-order/saveByInterior', server: 'mtdsaccount/account-order/saveByInterior' }, //订单保存接口(集团内部人员调用,不用扣费的)
            getK3Code: { mock: 'mtdsaccount/ucenterapi/internal/getK3Code', server: 'mtdsaccount/ucenterapi/internal/getK3Code' }, //订单保存接口(集团内部人员调用,不用扣费的)
            getAccountListByCon: { mock: 'mtdsaccount/account-charge-order/getAccountListByCon', server: 'mtdsaccount/account-charge-order/getAccountListByCon' }, //设计账号费用管理列表
            getBillingCostDetail: { mock: 'mtdsbilling/billing/billingCostDetail/getBillingCostDetail', server: 'mtdsbilling/billing/billingCostDetail/getBillingCostDetail' }, //清单明细查询
            batchCharge: { mock: 'mtdsaccount/account-charge-order/batchCharge', server: 'mtdsaccount/account-charge-order/batchCharge' }, //清单明细查询
            editAuditResultByInterior: { mock: '/account-audit/batchAuditOrdersByInterior', server: 'mtdsaccount/account-audit/batchAuditOrdersByInterior' }, //订单审核，通过，驳回，撤销

            getOpenCostDetailList: { mock: 'mtdsbilling/billing/billingCostDetail/getOpenCostDetailList', server: 'mtdsbilling/billing/billingCostDetail/getOpenCostDetailList' }, //设计账开通扣费清单确认接口
            getItemList: { mock: 'mtdsbilling/billing/billingItem/getItemList', server: 'mtdsbilling/billing/billingItem/getItemList' }, //设计账开通扣费清单确认接口
            // revokeOrder: { mock: 'mtdsbilling/billing/billingCostDetail/revokeOrder', server: 'mtdsbilling/billing/billingCostDetail/revokeOrder' }, //批量撤销订单
            revokeOrder: { mock: 'mtdsbilling/billing/designOrder/revokeDesignOrder', server: 'mtdsbilling/billing/designOrder/revokeDesignOrder' }, //批量撤销订单
            getRechargeCostDetailList: { mock: 'mtdsbilling/billing/billingCostDetail/getRechargeCostDetailList', server: 'mtdsbilling/billing/billingCostDetail/getRechargeCostDetailList' }, //设计账充值扣费清单确认接口
            getDesignOrderDetailList: { mock: 'mtdsbilling/billing/designOrder/getDesignOrderDetailList', server: 'mtdsbilling/billing/designOrder/getDesignOrderDetailList' }, //虚拟账户扣费清单管理功能
            getAccountInfoList: { mock: 'mtdsbilling/billing/accountInfo/getAccountInfoList', server: 'mtdsbilling/billing/accountInfo/getAccountInfoList' }, //虚拟账户信息查询功能
            suspendAccountInfo: { mock: 'mtdsbilling/billing/accountInfo/suspendAccountInfo', server: 'mtdsbilling/billing/accountInfo/suspendAccountInfo' }, //虚拟账户信息查询功能
            confirmDesignOrder: { mock: 'mtdsbilling/billing/designOrder/confirmDesignOrder', server: 'mtdsbilling/billing/designOrder/confirmDesignOrder' }, //批量实扣订单

        };
        this.api.payListMange = {
          getPayOrderPage: { mock: "mtdsbilling/billing/billingpay/getPayOrderPage", server: "mtdsbilling/billing/billingpay/getPayOrderPage" }, //第三方计费清单管理
          rechargeOrder: { mock: "mtdsbilling/billing/billingpay/rechargeOrder", server: "mtdsbilling/billing/billingpay/rechargeOrder" }, //提交充值接口

        }
    }


    /**
     * 格式化api链接
     * @Author BillionChen
     * @param  {Boolean}   isToMock [是否转为mock链接/若为false则会判断当前是否使用mock数据]
     * @param  {Boolean}   isStatic [是否静态api(没有ajax方法的配置链接)]
     * @return {[type]}             [description]
     */
    toUrl(isStatic = undefined) {
        let rs = {};
        for (let v in this.api) {
            rs[v] = {};
            for (let item in this.api[v]) {
                if (this.api[v][item].static !== isStatic) continue; //静态链接不纳入api
                // if (isToMock || process.env.MOCK_ON === 'mock' ) {
                //     this.api[v][item]["mock"]
                //         ? rs[v][item] = this.api[v][item]["mock"]
                //         : console.log(`mock url lost: api.${v}.${item}`)
                // }
                if (item === 'authorization') {
                    this.api[v][item]["mock"] ?
                        rs[v][item] = this.api[v][item]["mock"] :
                        console.log(`mock url lost: api.${v}.${item}`)
                } else {
                    this.api[v][item]["server"] ?
                        rs[v][item] = (this.api[v][item]['base'] ? this.api[v][item]['base'] : process.env.BASE_PATH) + this.api[v][item]["server"] :
                        console.log(`server url lost: api.${v}.${item}`)
                }
            }
        }
        return rs;
    }

    toApi(request = 'post') {
        let urlConfigs = this.toUrl();
        let rs = {};
        for (let module in urlConfigs) {
            rs[module] = {};

            if (request === 'get') {
                for (let item in urlConfigs[module]) {
                    rs[module][item] = (params = {}, headersStr = 'application/x-www-form-urlencoded; charset=utf-8') => {
                        return axios.get(urlConfigs[module][item], { params }, {
                                headers: {
                                    'Content-Type': headersStr,
                                    'Oauth2-AccessToken': this.getOauth2AccessToken()
                                },
                            })
                            .then(this.checkStatus)
                            .then(this.checkJson)
                            .then(this.checkError)
                    }
                }
            }

            if (request === 'put') {
                for (let item in urlConfigs[module]) {
                    rs[module][item] = (params = {}, headersStr = 'application/json; charset=utf-8') => {
                        return axios.put(urlConfigs[module][item], params, {
                                headers: {
                                    'Content-Type': headersStr,
                                    'Oauth2-AccessToken': this.getOauth2AccessToken()
                                },
                            })
                            .then(this.checkStatus)
                            .then(this.checkJson)
                            .then(this.checkError)
                    }
                }
            }

            if (request === 'post') {
                for (let item in urlConfigs[module]) {
                    rs[module][item] = (params = {}, headersStr = 'application/json; charset=utf-8') => {
                        return axios.post(urlConfigs[module][item], params, {
                                headers: {
                                    'Content-Type': headersStr,
                                    'Oauth2-AccessToken': this.getOauth2AccessToken()
                                },
                            })
                            .then(this.checkStatus)
                            .then(this.checkJson)
                            .then(this.checkError)
                    }
                }
            }
            // }
        }
        return rs;
    }

    toPost() {
        let urlConfigs = this.toUrl();
        let rs = {};
        for (let module in urlConfigs) {
            rs[module] = {}
            for (let item in urlConfigs[module]) {
                rs[module][item] = (params = {}, data = {}, headersStr = 'application/json; charset=utf-8') => {
                    // return axios.post(urlConfigs[module][item], params, {
                    //         headers: {
                    //             'Content-Type': headersStr,
                    //         },
                    //     })
                    return axios({
                            method: 'post',
                            url: urlConfigs[module][item],
                            params: params,
                            data: data,
                            headers: {
                                'Content-Type': headersStr,
                                'Oauth2-AccessToken': this.getOauth2AccessToken()
                            }
                        })
                        .then(this.checkStatus)
                        .then(this.checkJson)
                        .then(this.checkError)
                }
            }
        }
        return rs;
    }

    toPathVariable(request = 'get') {
        let urlConfigs = this.toUrl();
        let rs = {};
        for (let module in urlConfigs) {
            rs[module] = {}
            for (let item in urlConfigs[module]) {
                rs[module][item] = (path = {}, params = {}, data = {}, headersStr = 'application/json; charset=utf-8') => {
                    // return axios.post(urlConfigs[module][item], params, {
                    //         headers: {
                    //             'Content-Type': headersStr,
                    //         },
                    //     })
                    let url = urlConfigs[module][item];
                    for (var key in path) {
                        url = url.replace('{' + key + '}', path[key]);
                    }
                    if (request === 'post') {
                        return axios({
                                method: 'post',
                                url: url,
                                params: params,
                                data: data,
                                headers: {
                                    'Content-Type': headersStr,
                                    'Oauth2-AccessToken': this.getOauth2AccessToken()
                                }
                            })
                            .then(this.checkStatus)
                            .then(this.checkJson)
                            .then(this.checkError)
                    }
                    if (request === 'get') {
                        return axios({
                                method: 'get',
                                url: url,
                                params: params,
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                                }
                            })
                            .then(this.checkStatus)
                            .then(this.checkJson)
                            .then(this.checkError)
                    }

                }
            }
        }
        return rs;
    }


    checkStatus(response) {
        // debugger
        // 如果 http 状态码正常, 则直接返回数据
        // 异常状态下, 把错误信息返回去
        // 因为前面我们把错误扶正了, 不然像 404, 500 这样的错误是走不到这里的
        if (!response) {
            return {
                status: false,
                code: null,
                exception: "no response!please logout!",
                // login: false,
            } //未登录被302拦截后,没有返回//这里应该有坑的...但暂时是不会出问题的
        }
        if (response.status === 400 || response.status === 404 || response.status === 500) {
            return {
                status: false,
                data: null,
                message: response.message
            };
        }

        return [200, 304].indexOf(response.status) !== -1 ? response.data : {
            status: false,
            code: response.status,
            // msg: response.statusText,
            exception: [response.status, response.statusText, response.request.responseURL].join(" ")
                // data: response.statusText,
        }
    }

    checkJson(data) {
        return (typeof data).toLowerCase() === 'string' ?
            JSON.parse(data) :
            data
    }

    checkError(data) {
        if (data && data.status) {
            return data;
        } else {
            let elLoadingMask = document.querySelector('.el-loading-mask.is-fullscreen');
            if (elLoadingMask) {
                elLoadingMask.style.display = "none";
            }
            let codeArr = ['501', 'ECO001', 'ECO002', 'ECO003', 'ECO004', 'ECO005', 'ECO006', 'ECO007', 'ECO008', 'ECO009', 'ECO100', 'ECO101', 'ECO102', 'ECO103', 'ECO999'];
            // console.log('checkError', data)
            if (codeArr.join(',').indexOf(data.code) !== -1) {
                let msg = data.message || data.msg || data.exception || data.errMsg;
                // new Vue().$message.warning(msg);
                new Vue().$notify.error({
                    title: '错误',
                    message: msg
                });
                return data;
            }
            if (data.code === '500') {
                let msg = data.message || data.msg || data.exception || data.errMsg;
                new Vue().$message.error(msg);
            }

            if (['110001', '110013', '110016'].join(',').indexOf(data.code) !== -1) {
              window.location = `${data.data}${encodeURIComponent(location.href)}&AppCode=BILL&SubAppCode=BILLPC001`
              return data
            }

            if (!(data.code === '200' || data.code === "100000")) {
                let msg = data.message || data.msg || data.exception || data.errMsg || '系统错误，请稍后重试!';
                let elLoadingMask = document.querySelector('.el-loading-mask.is-fullscreen');
                if (elLoadingMask) {
                    elLoadingMask.style.display = "none";
                }
                data.msg = msg;
                new Vue().$message.error({
                    title: `服务器异常，请稍后再试！(${msg})`,
                    message: msg
                });
                return data;
            }
        }
        if (data && !data.status) {
            return data;
        }
    }

    getOauth2AccessToken() {
        if (getQueryString('Oauth2-AccessToken')) {
          setCookie('Oauth2-AccessToken')
        }
        return getQueryString("Oauth2-AccessToken") ? getQueryString("Oauth2-AccessToken") : getCookie("Oauth2-AccessToken")
    }
}

export const staticApi = new ApiConfig().toUrl(false, true);
export const getUrl = new ApiConfig().toUrl();
export const mock = new ApiConfig().toUrl(true);
export const apiGet = new ApiConfig().toApi('get');
export const apiPut = new ApiConfig().toApi('put');
export const api = new ApiConfig().toApi('post');
export const apiPost = new ApiConfig().toPost();
export const apiPathVariableGet = new ApiConfig().toPathVariable('get');
export const apiPathVariablePost = new ApiConfig().toPathVariable('post');



// WEBPACK FOOTER //
// ./src/api/index.js